/* eslint-disable import/no-cycle */
import { Select } from '@chakra-ui/core';
import React, { useCallback } from 'react';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';
import { INLINE_SELECT_PROPS } from './questionValidationRules/questionValidationRules.style';

interface QuestionUploadNumberSelectProps {
  elementId: string;
}
const path = 'maximumDocumentCount';

export const QuestionUploadNumberSelect = React.memo<QuestionUploadNumberSelectProps>(function QuestionUploadNumberSelect({
  elementId,
}) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  const valueSelector = React.useCallback((state) => state.getElementValue(elementId, path), [elementId]);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const value = QuestionnaireTemplateStore.useStoreState<number>(valueSelector);
  const updateValue = QuestionnaireTemplateStore.useStoreActions((actions) => actions.updateElementValue);

  const handleSelectionCountChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const { value: selected } = e.target;
      updateValue({ id: elementId, path, value: parseInt(selected, 10) });
    },
    [updateValue, elementId],
  );

  return (
    <Select display="inline-block" {...INLINE_SELECT_PROPS} value={value} onChange={handleSelectionCountChange}>
      <option value={1}>1</option>
      <option value={2}>2</option>
      <option value={3}>3</option>
    </Select>
  );
});
